
  <template>
  <div>
    <el-table
      style="width:100%"
      height="100%"
      :header-cell-style="getTableHead"
      :size="tableSize"
      :data="dataList"
      v-loading="loadObj.isLoading"
      border
      class="tapTableContainer"
      :stripe="options.stripe"
      :highlightCurrentRow="options.highlightCurrentRow"
      @sort-change="sortFunc($event)"
      @selection-change="handleSelect"
    >
      ">
      <el-table-column
        v-for="(item,index) in columns"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :key="item.index"
        :align="item.align"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <template v-if="item.render">
            <expand-dom :item="item" :row="scope.row" :render="item.render" :index="index"></expand-dom>
          </template>
          <template v-else>
            <template v-if="item.route">
              <el-button
                type="text"
                @click="item.method(scope.$index,scope.row)"
              >{{scope.row[item.prop]}}</el-button>
            </template>
            <template v-else>
              <span>{{scope.row[item.prop]}}</span>
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column type="expand" v-if="expandColumn" width="60px">
        <template slot-scope="scope">
          <el-form labelPosition="left" inline class="demo-table-expand" size="mini">
            <el-form-item
              v-for="(item,index) in expandColumn.expandList"
              :key="index"
              :label="item.label"
            >{{scope.row[item.prop]}}</el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="expand" v-if="showExpand">
        <template slot-scope="props"></template>
      </el-table-column>
      <el-table-column
        width="100"
        label="操作"
        v-if="operationColumn.show"
        :align="operationColumn.align"
        fixed="right"
      >
        <template slot-scope="scope">
          <div style="display:flex;flex-flow:row;justify-content:space-around">
            <div v-for="(item,index) in operationColumn.btns">
              <el-button
                :key="index"
                :size="item.size"
                :type="item.type"
                :icon="item.icon"
                :disabled="item.disabled"
                :style="item.style"
                @click.native="item.method(scope.$index,scope.row)"
              >
                <span>{{item.text}}</span>
              </el-button>
            </div>
            <div
              v-if="operationColumn.otherBtn"
              v-for="(obj,index) in operationColumn.otherBtn"
              :key="index"
            >
              <el-button
                :type="obj.type"
                :icon="obj.icon"
                v-if="obj.value.indexOf(scope.row[obj.item])!=-1"
                :size="obj.size"
                :style="obj.style"
                @click.native="obj.method(scope.$index,scope.row)"
              >{{obj.text}}</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBar">
      <el-pagination
        v-if="fenyeObj.showPage"
        @size-change="sizeChange($event)"
        @current-change="currentChange($event)"
        size="mini"
        background
        :current-page="fenyeObj.currentPage"
        :page-sizes="[10,20,50,100]"
        :page-size="fenyeObj.pageSize"
        :layout="fenyeObj.layoutString"
        :total="fenyeObj.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderType: "",
      showSelect: false
    }
  },
  watch: {
    orderType(i, j) {
      console.log(i)
    }
  },
  props: {
    showExpand: {
      type: Boolean,
      default: () => false
    },
    tableSize: {
      type: String,
      default: () => "medium"
    },
    dataList: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    operates: {},
    isLoading: {
      type: Boolean,
      default: () => false
    },
    fenyeObj: {
      type: Object,
      default: () => { }
    },
    options: {
      type: Object,
      default: () => { }
    },
    loadObj: {
      type: Object,
      default: () => { }
    },
    operationColumn: {
      type: Object,
      default: () => { }
    },
    expandColumn: {
      type: Object,
      default: () => null
    }
  },
  components: {
    expandDom: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null
        }
      },
      render: (h, ctx) => {
        const params = {
          row: ctx.props.row,
          index: ctx.props.index
        };
        if (ctx.props.column) {
          params.column = ctx.props.column;
        }
        return ctx.props.render(h, params);
      }
    }
  },
  methods: {
    getTableHead({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:	#2196F3;color:white;font-size:14px;opacity:0.9;padding:6px";
      } else {
        return "";
      }
    },
    sizeChange(e) {
      this.$emit("dataSizeChange", e);
    },
    currentChange(e) {
      this.$emit("dataCurrentChange", e);
    },
    sortFunc(e) {
      this.$emit("handleSort", e);
    },
    handleSelect(val) {
      console.log(val)
    },
    selectType(i, j) {
      console.log(i)
      console.log(j)
    }
  },
  mounted() {
    this.orderType = ""
  }
};
</script>
<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-left: 10%;
  margin-bottom: 0;
  width: 40%;
}
.pageBar {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
</style>


